<template>
  <div>
    <v-card-title>
      <h3 class="headline my-0">{{ $t('Modificación de datos de trabajador/a') }}</h3>
    </v-card-title>
    <v-divider light></v-divider>
    <v-card-text>
      <v-select
        v-model="formData.tipo_de_modificacion"
        :disabled="disabled"
        @input="$emit('input', formData)"
        :label="$t('Tipo de modificación')"
        :items="tiposDeModificacionDeContrato"
        item-text="label"
        item-value="value"
        :rules="[rules.required]"
        required
        box
        :menu-props="{
          bottom: true,
          'offset-y': true,
        }"
      ></v-select>

      <!-- <v-text-field
        v-if="'conversion_de_contrato_temporal_a_indefinido' === formData.tipo_de_modificacion"
        :label="$t('Fecha de efecto')"
        box
        v-model="formData.fecha_de_efecto"
        :disabled="disabled"
      ></v-text-field> -->
      <formacion-y-categoria-profesional
        v-if="'cambio_de_categoria_profesional' === formData.tipo_de_modificacion"
        v-model="formData"
        :disabled="disabled"
      ></formacion-y-categoria-profesional>
      <remuneracion
        v-if="'cambio_de_retribucion' === formData.tipo_de_modificacion"
        v-model="formData"
        :disabled="disabled"
      ></remuneracion>
      <jornada-laboral
        v-if="'cambio_de_jornada_laboral' === formData.tipo_de_modificacion"
        v-model="formData"
        :disabled="disabled"
      ></jornada-laboral>

      <v-textarea
        v-if="'otros' === formData.tipo_de_modificacion"
        v-model="formData.otras_modificaciones_texto"
        :disabled="disabled"
        :label="$t('Descripción de la modificación de contrato')"
        box
      ></v-textarea>
    </v-card-text>
  </div>
</template>

<script>
import Remuneracion from './laboral-inputs/Remuneracion.vue';
import JornadaLaboral from './laboral-inputs/JornadaLaboral.vue';
import FormacionYCategoriaProfesional from './laboral-inputs/FormacionYCategoriaProfesional.vue';

export default {
  components: { Remuneracion, JornadaLaboral, FormacionYCategoriaProfesional },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          tipo_de_modificacion: null,
          titulacion: null,
          categoria_profesional: null,
          jornada_laboral: null,
          jornada_laboral_horas_semanales: null,
          jornada_laboral_horario: null,
          fecha_de_efecto: null,
          otras_modificaciones_texto: null,
        };
      },
    },
  },
  data() {
    return {
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      tiposDeModificacionDeContrato: [
        { label: 'Cambio de jornada laboral', value: 'cambio_de_jornada_laboral' },
        { label: 'Cambio de retribución', value: 'cambio_de_retribucion' },
        {
          label: 'Conversión de contrato temporal a indefinido',
          value: 'conversion_de_contrato_temporal_a_indefinido',
        },
        { label: 'Cambio de categoría profesional', value: 'cambio_de_categoria_profesional' },
        { label: 'Otros', value: 'otros' },
      ],
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
